var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69989 6.93798C1.51856 6.68932 1.42789 6.56465 1.36523 6.32465C1.32292 6.11095 1.32292 5.89102 1.36523 5.67732C1.42789 5.43665 1.51856 5.31198 1.69989 5.06398C2.69256 3.70065 4.86856 1.33398 7.99989 1.33398C11.1312 1.33398 13.3072 3.70065 14.2999 5.06332C14.4812 5.31198 14.5719 5.43665 14.6346 5.67665C14.6769 5.89036 14.6769 6.11028 14.6346 6.32398C14.5719 6.56465 14.4812 6.68932 14.2999 6.93732C13.3072 8.30065 11.1312 10.6673 7.99989 10.6673C4.86856 10.6673 2.69256 8.30065 1.69989 6.93798Z",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 7.33464C8.35346 7.33464 8.6926 7.19416 8.94265 6.94411C9.19269 6.69406 9.33317 6.35492 9.33317 6.0013C9.33317 5.64768 9.19269 5.30854 8.94265 5.05849C8.6926 4.80844 8.35346 4.66797 7.99984 4.66797C7.64622 4.66797 7.30708 4.80844 7.05703 5.05849C6.80698 5.30854 6.6665 5.64768 6.6665 6.0013C6.6665 6.35492 6.80698 6.69406 7.05703 6.94411C7.30708 7.19416 7.64622 7.33464 7.99984 7.33464Z",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraTracking);
export default __webpack_public_path__ + "static/media/cameraTracking.886804e2b388958e717479d6e0a84a27.svg";
export { ForwardRef as ReactComponent };